/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min: NonNullable<unknown> }} Team_Manager_Add_Users_InvalidInputs */



/**
* | output |
* | --- |
* | "Enter a whole number from {min} to 50." |
*
* @param {Team_Manager_Add_Users_InvalidInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_add_users_invalid = /** @type {((inputs: Team_Manager_Add_Users_InvalidInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Add_Users_InvalidInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Saisissez un nombre entier de ${i?.min} à 50.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Geben Sie eine ganze Zahl von ${i?.min} bis 50 ein.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Inserisci un numero intero da ${i?.min} a 50.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Введите целое число от ${i?.min} до 50.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Introduce un número entero de ${i?.min} a 50.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`请输入 ${i?.min} 到 50 之间的整数。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.min} から 50 までの整数を入力してください。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.min} से 50 के बीच कोई पूर्ण संख्या दर्ज करें।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Introduza um número inteiro de ${i?.min} a 50.`)
	return /** @type {LocalizedString} */ (`Enter a whole number from ${i?.min} to 50.`)
});